var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-shrink-0 bl-icon-component",
      attrs: { "data-id": _vm.dataId }
    },
    [
      _c("div", {
        ref: "blComponent",
        staticClass: "bl-component-svg",
        class:
          (_vm.color ? "bl-color-" + _vm.color : "") +
          " " +
          (_vm.clickable ? "bl-clickable" : ""),
        attrs: { "data-id": _vm.dataId },
        on: { click: _vm.click }
      }),
      _vm._v(" "),
      _vm.tooltip
        ? _c(
            "div",
            {
              staticClass: "bl-icon-tooltip",
              class: [
                _vm.tooltipPosition
                  ? "bl-icon-tooltip-" + _vm.tooltipPosition
                  : ""
              ]
            },
            [
              _c("BlTextBody3", {
                staticClass: "bl-icon-tooltip-text",
                attrs: { text: _vm.tooltip }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-564cf6da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-564cf6da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlIcon.vue
// module id = null
// module chunks = 